import {Dispatch, SetStateAction, useEffect, useState} from 'react'
import {Field, FormikProps} from 'formik'
import {useIntl} from 'react-intl'
import TextInput from '../../widgets/components/Input/TextInput'
import CustomSearchSelectInput from '../../widgets/components/Input/CustomSearchSelectInput'
import {getTemplatesForDropdownApi} from '../core/_requests'
import {useAuth} from '../../auth'
import {DocumentFormValues} from '../core/_models'
import {ToolTipUIForModal} from '../../widgets/components/UI/ToolTipUIForModal'

const DocumentGeneralDetails = ({
  setTemplateId,
  formik,
  showModal,
  templateDocusealId,
  isUpdateTemplateDropdown,
  isDuplicateDocument,
}: {
  setTemplateId: Dispatch<SetStateAction<number | undefined>>
  formik: FormikProps<DocumentFormValues>
  showModal: boolean
  templateDocusealId: number | undefined
  isUpdateTemplateDropdown: boolean
  isDuplicateDocument: boolean
}) => {
  const {formatMessage} = useIntl()
  const [options, setOptions] = useState([])
  const {companyId} = useAuth()

  useEffect(() => {
    if (showModal || templateDocusealId) {
      getAllTemplatesForDropdown()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal, isUpdateTemplateDropdown])

  const getAllTemplatesForDropdown = async () => {
    try {
      const {
        data: {data},
      } = await getTemplatesForDropdownApi(companyId!)
      if (data) {
        let filteredData
        if (isDuplicateDocument) {         
          const privateTemplates = data.filter(
            ({docusealId, isTemplateVisible}: {docusealId: number; isTemplateVisible: boolean}) =>
              docusealId === templateDocusealId || isTemplateVisible
          )
          filteredData = privateTemplates.map(
            ({templateId, title}: {templateId: number; title: string}) => ({
              id: templateId,
              label: title,
              value: templateId,
            })
          )
        } else {
          const publicTempaltes = data.filter(
            ({isTemplateVisible}: {isTemplateVisible: boolean}) => isTemplateVisible
          )
          filteredData = publicTempaltes.map(
            ({templateId, title}: {templateId: number; title: string}) => ({
              id: templateId,
              label: title,
              value: templateId,
            })
          )
        }
        setOptions(filteredData)
        if (templateDocusealId) {
          const documentTemplate = filteredData.find(
            ({docusealId}: {docusealId: number}) => docusealId === templateDocusealId
          )
          if (documentTemplate) {           
            formik.setFieldValue('templateId', {
              id: documentTemplate.templateId,
              label: documentTemplate.title,
              value: documentTemplate.templateId,
            })

            setTemplateId(documentTemplate.templateId)
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div>
      <div className='mt-10'>
        <div className='d-md-flex gap-4'>
          <div className='w-100 w-md-50'>
            <TextInput
              isDisabled={false}
              fieldName={'title'}
              fieldType={'text'}
              formik={formik}
              placeholder={formatMessage({id: 'Enter Document Name'})}
              label={formatMessage({id: 'Document Name'})}
              isStarRequired={true}
              isMargin='mb-5 mb-md-3'
              toolTipText={formatMessage({
                id: 'Please mention the title of the document',
              })}
              isTooltipForModal={true}
            />
          </div>
          <div className='mb-3 w-49 w-full-mobile mb-5 mb-md-0'>
            <div className='d-flex'>
              <label className='form-label font-size-13 text-dark text-capitalize ms-md-0'>
                {formatMessage({id: 'Select Template, if any'})}
              </label>
              <ToolTipUIForModal
                tooltipText={formatMessage({
                  id: 'Please select the template from which you want to create the document',
                })}
              />
            </div>
            <Field
              name='templateId'
              component={CustomSearchSelectInput}
              options={options}
              setTemplateId={setTemplateId}
              disable={false}
            />
          </div>
        </div>
        <div className='mt-3 me-2 w-md-50 w-100'>
          <TextInput
            fieldType={'date'}
            label={formatMessage({id: 'Expiry Date'})}
            fieldName={'expiryDate'}
            formik={formik}
            placeholder={formatMessage({id: 'Select Date'})}
            isStarRequired={false}
            isDateField={true}
            isTooltipForModal={true}
            toolTipText={formatMessage({
              id: 'Please mention the date by which this signatories has to sign this document i.e.expiry date.',
            })}
          />
        </div>
      </div>
    </div>
  )
}

export default DocumentGeneralDetails
